import { Module, Action, Mutation } from "vuex-module-decorators";
import { RootState } from "@/store";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { queryRequest } from "@/utils/request";
import {
  getWarrantyFeedback,
  queryK2WarrantyFeedback
} from "@/graphql/claim.gql";
import type { PaginationDataState } from "@/types";

export interface ClaimRecordModuleState extends PaginationDataState {
  searchCondition: any;
}

//默认搜索条件
const defaultSearchCondition = () => ({
  keyword: ""
});

@Module({ name: "ClaimRecordModule", namespaced: true })
export default class ClaimRecordModule
  extends PaginationModule<ClaimRecordModuleState, RootState>
  implements ClaimRecordModuleState {
  public listData = [];
  public detail: any = {};
  public searchCondition: any = {};

  @Mutation
  saveSearchConditionMutation(data = defaultSearchCondition()) {
    this.searchCondition = data ?? {};
  }

  @Mutation
  saveDetailMutation(data: any) {
    this.detail = data ?? {};
  }

  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }

  @Action
  searchAction() {
    this.paginationData.pageNum = 1;
    this.context.dispatch("initListAction");
  }

  @Action
  async initListAction(variables: any) {
    let {
      state: {
        paginationData: { pageNum, pageSize },
        searchCondition
      }
    } = this.context;
    const {
      dataList = [],
      pageInfo: { totalCount }
    } = await queryRequest({
      query: queryK2WarrantyFeedback,
      variables: {
        input: { ...variables, ownerMobile: searchCondition.keyword },
        pageInput: { pageNum, pageSize }
      }
    });
    let {
      commit,
      state: { paginationData }
    } = this.context;

    let allData = dataList.map(item => item.data);

    commit(
      paginationData.pageNum === 1
        ? "saveListDataMutation"
        : "addListDataMutation",
      allData
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  async getWarrantyFeedbackAction(variables: any) {
    const data = await queryRequest({
      query: getWarrantyFeedback,
      variables
    });
    this.context.commit("saveDetailMutation", data);
    return data;
  }
}
